import * as React from 'react';
import { SVGProps } from 'react';

const SvgEvisit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M28.3 7c.6 0 1 .5 1 1v24.9c0 .6-.5 1-1 1H12c-.6 0-1-.5-1-1V8.1c0-.6.5-1.1 1-1.1h16.3Z"
      clipRule="evenodd"
    />
    <path
      fill={props.fill}
      d="M14 31.5v-4h8.2l.4.4-.5.9 2.1 1.6.6-.3 1.4 1.4H14Z"
    />
    <path fill="currentColor" d="M15.3 7.7h9.6v2h-9.6z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.7 28.2c0-1.6 1.3-2.8 2.8-2.8 1.6 0 2.8 1.3 2.8 2.8 0 1.6-1.3 2.8-2.8 2.8-1.6 0-2.8-1.3-2.8-2.8Zm.9.3 1.4 1.4 2.4-2.4-.8-.8-1.6 1.6-.6-.6-.8.8Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M14 13h12.2M14 16.4h12.2M14 19.9h12.2M14 23.4h8.1"
    />
  </svg>
);

export default SvgEvisit;
